import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'spv2-cookie-notice',
  templateUrl: './cookie-notice.component.html',
  styleUrls: ['./cookie-notice.component.scss']
})
export class CookieNoticeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
